// document.addEventListener('DOMContentLoaded', function () {
//   const headings = document.querySelectorAll('.banner__heading');

//   headings.forEach(function (heading) {
//     const targetText = 'BUILT FOR SAFETY. BUILT TO LAST.';

//     if (heading.textContent.includes(targetText)) {
//       heading.innerHTML = heading.innerHTML.replace(
//         targetText,
//         '<span class="gold-banner">' + targetText + '</span>'
//       );
//     }
//   });
// });

// $(document).ready(function () {
//     $('.banner__heading').html(function (_, html) {
//         return html.replace(
//             'TRUSTED MINING EQUIPMENT BUILT FOR SAFETY. BUILT TO LAST.',
//             'TRUSTED MINING<br>EQUIPMENT<br><span class="gold-banner">BUILT FOR SAFETY.<br>BUILT TO LAST.</span>'
//         );
//     });
// });

// Review Section Link

$(document).ready(function () {
  var link = "https://app.judge.me/reviews/stores/www.maddenmining.com.au";

  var $target = $(
    "#shopify-block-AZ1hHQ0k4Q2RnRFhQQ__judge_me_reviews_cards_carousel_KEcwqK > div > div.jdgm-header > div"
  );

  if (!$target.length) return;

  $target
    .css("cursor", "pointer")
    .attr({
      role: "link",
      tabindex: "0"
    })
    .on("click", function () {
      window.open(link, "_blank");
    })
    .on("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        window.open(link, "_blank");
      }
    });
});